import { render } from "./HomeBlockProjects.vue?vue&type=template&id=4ec275d6&scoped=true"
import script from "./HomeBlockProjects.vue?vue&type=script&lang=js"
export * from "./HomeBlockProjects.vue?vue&type=script&lang=js"

import "./HomeBlockProjects.vue?vue&type=style&index=0&id=4ec275d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec275d6"]])

export default __exports__